<p class="section-description">
  Composed snapshots of the Recovery Environment and Failback sub-tabs. Pick a scenario to drive every part of the
  screen at once: status bar, operation-status notice, sub-tab heading, and resource table.
</p>

<label class="recovery-screen-picker">
  <span class="recovery-screen-picker-label">Scenario</span>
  <select class="arpio-select" (change)="setRecoveryScreenScenario($any($event.target).value)">
    @for (group of recoveryScreenScenarioGroups; track group.group) {
      <optgroup [label]="group.label">
        @for (scenario of group.scenarios; track scenario.key) {
          <option [value]="scenario.key" [selected]="scenario.key === recoveryScreenScenarioKey">
            {{ scenario.label }}
          </option>
        }
      </optgroup>
    }
  </select>
</label>
<p class="recovery-screen-description">{{ recoveryScreenActiveScenario.description }}</p>

<showcase-screen-preview
  [flags]="recoveryScreenActiveScenario.tabBarFlags"
  activeTab="recovery"
  [showRefreshBar]="true"
>
  <!-- Sub-tab heading (Recovery / Failback chips). Only shown when the scenario is
       in FAILOVER and not quarantined, mirroring production's failback visibility —
       STANDBY / FAILOVER_TEST / CLEANUP / quarantined scenarios render no sub-tabs. -->
  @if (screenShowsFailbackSubTabs) {
    <div class="tab-heading">
      <div class="tab">
        <button type="button" [ngClass]="{ active: !screenIsFailbackTab }">
          <h3 [ngClass]="{ inactive: screenIsFailbackTab }">Recovery</h3>
        </button>
        <button type="button" [ngClass]="{ active: screenIsFailbackTab }">
          <h3 [ngClass]="{ inactive: !screenIsFailbackTab }">Failback</h3>
        </button>
      </div>
    </div>
  }

  <showcase-status-bar [status]="screenStatus"></showcase-status-bar>

  <!-- Recovery operation-status notice. Mirrors the gating in
       application.component.html — only on the Recovery sub-tab, and only when the
       scenario provides operationNotice data (non-standby). -->
  @if (!screenIsFailbackTab && screenNotice) {
    <div class="operation-status-notice operation-status-notice--static">
      <svg lucideInfo></svg>
      <div class="operation-status-content">
        <span class="operation-status-summary">
          Applied recovery point is {{ screenNotice.recoveryPointTimeString }}.
          @if (screenNotice.showNetworkSandboxStatus) {
            Network sandbox is {{ screenNotice.networkSandboxStatus }}.
            @if (screenNotice.showSandboxEventsLink) {
              <a href="javascript:void(0)" role="button">See most recent events.</a>
            }
          }
          @if (screenNotice.showRansomwareRecoveryStatus) {
            Quarantine Mode is {{ screenNotice.ransomwareRecoveryStatus }}.
          }
        </span>
        @if (screenNotice.domainAllowlistStatus) {
          <div class="allowlist-status">
            <span class="allowlist-text">{{ screenNotice.domainAllowlistStatus }}</span>
          </div>
        }
        @if (screenNotice.whitelistStatus) {
          <div class="allowlist-status">
            <span class="allowlist-text">{{ screenNotice.whitelistStatus }}</span>
          </div>
        }
      </div>
    </div>
  }

  <!-- Failback operation notice. State-aware text mirrors the
       application.component.ts failbackOperationNoticeText getter. -->
  @if (screenIsFailbackTab && screenFailbackNoticeText) {
    <div class="operation-status-notice operation-status-notice--static">
      <svg lucideInfo></svg>
      <div class="operation-status-content">{{ screenFailbackNoticeText }}</div>
    </div>
  }

  <app-resources-view
    [resources]="screenResources"
    [tabType]="screenTabType"
    [application]="screenApp"
    [loading]="false"
    [statusContext]="StatusContext.RECOVERY"
  ></app-resources-view>
</showcase-screen-preview>
